export const signupFlowSteps = [
  'Get Started',
  'Address',
  'Ecosystem',
  'Subscription',
  'Payment',
  'Review',
];

export default signupFlowSteps;
